import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { FC, useState } from 'react';
import { formatDate } from '../../../utils/dateUtils';

interface ConfirmDialogProps {
  title: string;
  message: string;
  dateInit?: Date;
  enableDateInput?: boolean;
  onValidate: (date: Date) => void;
  onCancel: () => void;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  title,
  message,
  dateInit,
  enableDateInput,
  onValidate,
  onCancel,
}) => {
  const [internalDate, setInternalDate] = useState(
    formatDate(dateInit || new Date(), "yyyy-MM-dd'T'HH:mm"),
  );

  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', alignItems: 'baseline' }}>
        {/* eslint-disable-next-line react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: message }} />
        {enableDateInput && (
          <TextField
            id="datetime-local"
            inputProps={{
              min: '1970-01-01T00:00',
              max: '2100-01-01T00:00',
            }}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={({ target }) => {
              setInternalDate(target.value);
            }}
            type="datetime-local"
            value={internalDate}
            variant="standard"
            sx={{ ml: 1 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => onCancel()}>
          Annuler
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            onValidate(internalDate ? new Date(internalDate) : new Date())
          }
        >
          Valider
        </Button>
      </DialogActions>
    </>
  );
};
